import { createContext, useContext } from 'react';

const NavContext = createContext({
  collapsed: false,
  setCollapsed: () => {},
});

export const useNav = () => useContext(NavContext);

export default NavContext;
